const aaa = [
	{
		path: "messageList",
		component: () => import("@/views/oa/message/list.vue"),
		meta:{title:"app消息配置"},
	},{
		path: "weixinList",
		component: () => import("@/views/oa/weixin/list.vue"),
		meta:{title:"企业微信消息配置"},
	},{
		path: "publicList",
		component: () => import("@/views/oa/public/list.vue"),
		meta:{title:"公众号消息配置"},
	},
	
]
export default aaa;
  